import { Component, EventEmitter, Input, Output, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PeopleflowFooterComponent } from '../../../peopleflow-footer/peopleflow-footer.component';
@Component({
  standalone: true,
  selector: 'app-success-online-exam',
  templateUrl: './success-online-exam.component.html',
  styleUrl: './success-online-exam.component.scss',
  imports: [CommonModule, PeopleflowFooterComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SuccessOnlineExamComponent {
  [key: string]: any;
  constructor() {
  }

}
